import uiCopyToClipboardTranslationsEn from '../ui-copy-to-clipboard/en.translations.json.js';
import uiCopyToClipboardTranslationsDe from '../ui-copy-to-clipboard/de.translations.json.js';
import uiCopyToClipboardTranslationsEs from '../ui-copy-to-clipboard/es.translations.json.js';
import uiCopyToClipboardTranslationsFr from '../ui-copy-to-clipboard/fr.translations.json.js';
import uiCopyToClipboardTranslationsIt from '../ui-copy-to-clipboard/it.translations.json.js';
import uiCopyToClipboardTranslationsNl from '../ui-copy-to-clipboard/nl.translations.json.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';
import { uiAssetClassBadgeTranslationsEn, uiAssetClassBadgeTranslationsDe, uiAssetClassBadgeTranslationsFr, uiAssetClassBadgeTranslationsIt, uiAssetClassBadgeTranslationsEs, uiAssetClassBadgeTranslationsNl } from '../ui-asset-class-badge/index.js';
import { marketSelectorTranslationsEn, marketSelectorTranslationsDe, marketSelectorTranslationsFr, marketSelectorTranslationsIt, marketSelectorTranslationsEs, marketSelectorTranslationsNl } from '../market-selector/index.js';
import en from './en.translations.json.js';
import de from './de.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import es from './es.translations.json.js';
import nl from './nl.translations.json.js';

const factsheetHeaderTranslationsEn = {
  ...en,
  ...uiCopyToClipboardTranslationsEn,
  ...uiAssetClassBadgeTranslationsEn,
  ...marketSelectorTranslationsEn,
  ...localizationSupportTranslationsEn
};
const factsheetHeaderTranslationsDe = {
  ...de,
  ...uiCopyToClipboardTranslationsDe,
  ...uiAssetClassBadgeTranslationsDe,
  ...marketSelectorTranslationsDe,
  ...localizationSupportTranslationsDe
};
const factsheetHeaderTranslationsFr = {
  ...fr,
  ...uiCopyToClipboardTranslationsFr,
  ...uiAssetClassBadgeTranslationsFr,
  ...marketSelectorTranslationsFr,
  ...localizationSupportTranslationsFr
};
const factsheetHeaderTranslationsIt = {
  ...it,
  ...uiCopyToClipboardTranslationsIt,
  ...uiAssetClassBadgeTranslationsIt,
  ...marketSelectorTranslationsIt,
  ...localizationSupportTranslationsIt
};
const factsheetHeaderTranslationsEs = {
  ...es,
  ...uiCopyToClipboardTranslationsEs,
  ...uiAssetClassBadgeTranslationsEs,
  ...marketSelectorTranslationsEs,
  ...localizationSupportTranslationsEs
};
const factsheetHeaderTranslationsNl = {
  ...nl,
  ...uiCopyToClipboardTranslationsNl,
  ...uiAssetClassBadgeTranslationsNl,
  ...marketSelectorTranslationsNl,
  ...localizationSupportTranslationsNl
};
const factsheetHeaderTranslationsBundle = {
  en: factsheetHeaderTranslationsEn,
  de: factsheetHeaderTranslationsDe,
  fr: factsheetHeaderTranslationsFr,
  it: factsheetHeaderTranslationsIt,
  es: factsheetHeaderTranslationsEs,
  nl: factsheetHeaderTranslationsNl
};

export { factsheetHeaderTranslationsBundle, factsheetHeaderTranslationsDe, factsheetHeaderTranslationsEn, factsheetHeaderTranslationsEs, factsheetHeaderTranslationsFr, factsheetHeaderTranslationsIt, factsheetHeaderTranslationsNl };
